import { apiClient } from './api';

export const callerIdService = {
  initiateVerification: (phoneNumber: string, friendlyName: string) =>
    apiClient.post('/synth/caller-id/verify', {
      phone_number: phoneNumber,
      friendly_name: friendlyName,
    }),

  checkStatus: (phoneNumber: string) =>
    apiClient.get('/synth/caller-id/status', {
      params: { phone_number: phoneNumber },
    }),

  listVerified: () =>
    apiClient.get('/synth/caller-id/list'),

  removeVerified: (phoneNumber: string) =>
    apiClient.delete(`/synth/caller-id/${encodeURIComponent(phoneNumber)}`),
};
